// extracted by mini-css-extract-plugin
export default {"AsSeenOn":"Hero_AsSeenOn__AKkCd","golden":"Hero_golden__YH70P","HeroText":"Hero_HeroText__SAM3R"};